import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import { Card } from '../components/ui/Card';
import { Spinner } from '../components/ui/Spinner';
import { Table, type Column } from '../components/ui/Table';
import { useAuth } from '../context/AuthContext';
import type { TopCampaign, TopPage, TopReferrer } from '../types';

const pageColumns: Column<TopPage>[] = [
  { header: 'Landingpage', cell: (r) => <span className="font-mono text-xs">{r.path}</span> },
  { header: 'Aufrufe', cell: (r) => r.views, align: 'right' },
];

const referrerColumns: Column<TopReferrer>[] = [
  { header: 'Referrer', cell: (r) => r.referrer },
  { header: 'Sessions', cell: (r) => r.sessions, align: 'right' },
];

const campaignColumns: Column<TopCampaign>[] = [
  { header: 'Kampagne', cell: (r) => r.campaign ?? '—' },
  { header: 'Quelle / Medium', cell: (r) => `${r.source ?? '—'} / ${r.medium ?? '—'}` },
  { header: 'Sessions', cell: (r) => r.sessions, align: 'right' },
];

export function Campaigns() {
  const { currentSiteId } = useAuth();
  const to = new Date().toISOString();
  const from = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString();
  const range = [from.slice(0, 10), to.slice(0, 10)];

  const pages = useQuery({
    queryKey: ['top-pages', currentSiteId, ...range],
    queryFn: () => api.topPages(currentSiteId!, from, to),
    enabled: !!currentSiteId,
  });
  const referrers = useQuery({
    queryKey: ['top-referrers', currentSiteId, ...range],
    queryFn: () => api.topReferrers(currentSiteId!, from, to),
    enabled: !!currentSiteId,
  });
  const campaigns = useQuery({
    queryKey: ['top-campaigns', currentSiteId, ...range],
    queryFn: () => api.topCampaigns(currentSiteId!, from, to),
    enabled: !!currentSiteId,
  });

  return (
    <div className="space-y-6">
      <h1 className="text-xl font-semibold text-slate-900 dark:text-white">Kampagnen (letzte 30 Tage)</h1>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <Card title="Top Landingpages">
          {pages.isLoading ? <Spinner /> : <Table columns={pageColumns} rows={pages.data?.pages ?? []} />}
        </Card>
        <Card title="Top Referrer">
          {referrers.isLoading ? <Spinner /> : <Table columns={referrerColumns} rows={referrers.data?.referrers ?? []} />}
        </Card>
      </div>

      <Card title="UTM-Kampagnen">
        {campaigns.isLoading ? <Spinner /> : <Table columns={campaignColumns} rows={campaigns.data?.campaigns ?? []} />}
      </Card>
    </div>
  );
}
